module.exports = __webpack_public_path__ + "media/images/favicon/secondary/android-icon-144x144-6ac9d347eee93fff93802722eef824fd.png";